<template>
    <div class="home">
        <MainMenu></MainMenu>
    </div>
</template>

<script>
import MainMenu from '@/components/MainMenu.vue'


export default {
  name: 'Home',
  components: {
    MainMenu
  },
}
</script>
